import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import { useMutation, useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";

const getAllUserMaster = async ({ companyCode, locationCode }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetUserMasters}?companyCode=${companyCode}&LocationCode=${locationCode}`
  );
  return data;
};

const getUserMaster = async ({ code, companyCode }) => {
  console.log(
    `${Api_EndPoints.GetUserMaster}?UserID=${code}&companyCode=${companyCode}`
  );
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetUserMaster}?UserID=${code}&companyCode=${companyCode}`
  );
  return data;
};

const insertUserMaster = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.InsertUserMaster,
    input
  );
  return data;
};

const updateUserMaster = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.UpdateUserMaster,
    input
  );
  return data;
};

const deleteUserMaster = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.DeleteUserMaster}?CompanyCode=${companyCode}&UserID=${code}`
  );
  return data;
};

export const useGetAllUserMasterQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetUserMasters],
    queryFn: () => getAllUserMaster(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetUserMasterByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetUserMaster],
    queryFn: () => getUserMaster(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertUserMasterMutation = () => {
  return useMutation({
    mutationFn: insertUserMaster,
  });
};

export const useUpdateUserMasterMutation = () => {
  return useMutation({
    mutationFn: updateUserMaster,
  });
};

export const useDeleteUserMasterMutation = () => {
  return useMutation({
    mutationFn: deleteUserMaster,
  });
};
